import React from 'react'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const IdlePeriodDeactivateForm: React.VFC = () => {
  const { t } = useCustomTranslation()
  return (
    <Box>
      <Typography variant={'body1'}>
        {t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.dialogs.toggleAll.deactivateView.description')}
      </Typography>
    </Box>
  )
}

export default IdlePeriodDeactivateForm
